import { Box, SxProps, Theme } from "@mui/material";
import { Header } from "@tanstack/react-table";
import { IconCaret } from "src/components/icons-mui/caret";
import { SortDirection } from "src/constants/sort-direction";

interface ITableSortingIcon<T> {
    header: Header<T, unknown>;
    sx?: SxProps<Theme>;
}

interface ISortableNotActiveIconProps {
    sx?: SxProps<Theme>;
}

const SortableNotActiveIcon = ({ sx }: ISortableNotActiveIconProps) => (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", ...sx }}>
        <IconCaret sx={{ color: "gray.300", fontSize: "md", transform: "rotate(180deg)" }} />
        <IconCaret sx={{ color: "gray.300", fontSize: "md", mt: "-7px" }} />
    </Box>
);

export const TableSortingIcon = <T,>({ header, sx }: ITableSortingIcon<T>) => {
    if (header.column.columnDef.enableSorting === false) {
        return null;
    }

    const sortDirection = header.column.getIsSorted();

    if (!sortDirection) {
        return <SortableNotActiveIcon sx={sx} />;
    }

    const rotationAngle = sortDirection === SortDirection.Descending ? 0 : 180;

    return (
        <IconCaret
            sx={{
                color: "gray.800",
                transition: "transform 0.2s",
                transform: `rotate(${rotationAngle}deg)`,
                fontSize: "md",
                ...sx,
            }}
        />
    );
};
